module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/box_icon-8b5a9932e109ed86a4d72b71ec9bc1a6.svg";